// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"886f26f8","42":"f2cd1ac4","90":"d3112b22","216":"ea17d162","243":"f0feb75d","267":"b9f64629","278":"76ef8741","330":"a374c7e2","389":"401ce143","487":"38fd63c0","514":"72e1b02d","542":"bbdf3f97","588":"94a362da","715":"506e5e0f"}[chunkId] + ".chunk.js";
};